import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Injectable, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarService } from '../calendar/calendar.service';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'app-message-feed-dialog',
  templateUrl: './message-feed-dialog.component.html',
  styleUrls: ['./message-feed-dialog.component.scss'],
})
export class MessageFeedDialogComponent implements OnInit {
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(private activeModal: NgbActiveModal, private calendarService: CalendarService, private authSerivce: AuthService, private datepipe: DatePipe,     private CD: ChangeDetectorRef) {}

  form: FormGroup;

  ngOnInit() {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      text: new FormControl('', Validators.required),
    });
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    if(!this.form.valid) {
      return;
    }
    this.calendarService.createMessageFeed(this.form.value.title, this.form.value.text, this.authSerivce.getUserName() ,this.datepipe.transform(new Date(), 'YYYY.mm.dd hh:mm')).subscribe(success => {
      this.CD.detectChanges();
    })
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
